var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgReplay24Px = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 20,
  viewBox: "0 0 16 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.92874 3.29153V0.501534C7.92874 0.0515344 7.38874 -0.168466 7.07874 0.151534L3.27874 3.94153C3.07874 4.14153 3.07874 4.45153 3.27874 4.65153L7.06874 8.44153C7.38874 8.75153 7.92874 8.53153 7.92874 8.08153V5.29153C11.6587 5.29153 14.6087 8.71153 13.7887 12.5815C13.3187 14.8515 11.4787 16.6815 9.21874 17.1515C5.64874 17.9015 2.46874 15.4515 1.98874 12.1415C1.91874 11.6615 1.49874 11.2915 1.00874 11.2915C0.408739 11.2915 -0.0712611 11.8215 0.00873893 12.4215C0.628739 16.8115 4.80874 20.0615 9.53874 19.1415C12.6587 18.5315 15.1687 16.0215 15.7787 12.9015C16.7687 7.77153 12.8687 3.29153 7.92874 3.29153Z",
  fill: "#7F7F7F"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgReplay24Px);
export { ForwardRef as ReactComponent };